import {
    VERIFY_USER_INFO,
    REGISTER,
    REGISTER_PAGE_GETPINCODE,
    REGISTER_PAGE_UNLOADED,
    LOGIN,
    PHONE_LOGIN_GET_PINCODE,
    PHONE_LOGIN_PAGE_LOADED,
    PHONE_LOGIN_PAGE_UNLOADED,
    GET_PIN_CODE,
    LOGIN_PAGE_VERIFY_PIN_CODE,
    VERIFY_PIN_CODE_UNLOADED,
    PHONE_LOGIN_SUBMIT,
    LOGIN_PAGE_UNLOADED,
    VERIFYID_PAGE_LOADED,
    FORGOTPASSWORD,
    RESETPASSWORD,
    RESETPASSWORD_PAGE_UNLOADED,
    FORGOTPASSWORD_UNLOADED,
} from '../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case VERIFY_USER_INFO: {
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                verified: action.error ? false : action.payload.verified,
                userInfo: action.userInfo
            }
        }
        case REGISTER:
            return {
                ...state,
                issuer_type: action.issuer_type,
                errors: action.error ? action.payload.error : null,
            };
        case LOGIN:
            return {
                ...state,
                user: action.error ? null : action.payload.user,
                userKey: action.error ? null : action.payload.user_key,
                phone: action.error ? null : action.payload.phone,
                errors: action.error ? action.payload.error : null
            };
        case PHONE_LOGIN_GET_PINCODE:
            return {
                ...state,
                userKey: action.error ? null : action.payload.user_key,
                phone: action.error ? null : action.payload.phone,
                errors: action.error ? action.payload.error : null
            };
        case GET_PIN_CODE:
        case LOGIN_PAGE_VERIFY_PIN_CODE:
        case PHONE_LOGIN_SUBMIT:
            return {
                ...state,
                errors: action.error ? action.payload.error : null
            };
        case REGISTER_PAGE_GETPINCODE:
            return {
                ...state,
                errors: null,
                sms_requested: true,
                phone_errors: action.error ? action.payload.error : null,
            };
        case VERIFYID_PAGE_LOADED:
            return {
                ...state,
                userIds: action.error ? null : action.payload.ids
            }
        case LOGIN_PAGE_UNLOADED:
        case REGISTER_PAGE_UNLOADED:
        case VERIFY_PIN_CODE_UNLOADED:
        case RESETPASSWORD_PAGE_UNLOADED:
        case FORGOTPASSWORD_UNLOADED:
        case PHONE_LOGIN_PAGE_UNLOADED:
            return {};
        case FORGOTPASSWORD:
        case RESETPASSWORD:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                redirectTo: action.error ? null : action.redirectTo,
            }
        default:
            return state;
    }
};
